module.exports = __webpack_public_path__ + "static/media/MY.d40c11d4.svg";